import { DatabaseFieldType } from '@databases/types/database';

export const ContentSelectionModeMap = {
  row: 'entry',
  column: 'field',
  cell: 'value',
} as const;

export const DEPENDENCY_FIELD_TYPES = new Set([
  DatabaseFieldType.PAGE_DETAILS,
  DatabaseFieldType.JIRA_ISSUE_DETAILS,
  DatabaseFieldType.ENTRY_DETAILS,
  DatabaseFieldType.BACKLINK,
  DatabaseFieldType.PAGE_STATUS,
  DatabaseFieldType.PAGE_LABELS,
]);
